import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import itc from "../../../assets/images/services/hireing.png";
import ServiceSidebar2 from '../ServiceSidebar2/Main'
import { useTranslation } from 'react-i18next';


const HireingDev = () => {
	// const [clicked, setClicked] = useState(0);
	// const faqs = [
	// 	{
	// 		question: "Nulla eu nisi pellentesque, ultrices lorem eget, mattis dolo",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Praesent nec ante sed libero tempus rutrum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Integer et mi in eros commodo bibendum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Proin commodo turpis eu leo tempus varius",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	}
	// ]
  const { t } = useTranslation();
	return (
    <>
      <Breadcumb
        Title={t('hire_development.breadcrumb_title')}
        Breadcumb={t('hire_development.breadcrumb_parent')}
      />

      <section className="section-padding--bottom section-padding--top service-details--page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="service-details__image">
                <img src={itc} alt="" />
              </div>

              <h3 className="service-details__title">
                {t('hire_development.page_title')}
              </h3>

              <div className="service-details__content">
                <p>{t('hire_development.intro_p1')}</p>
                <p>{t('hire_development.intro_p2')}</p>
                <p>{t('hire_development.intro_p3')}</p>
                <p>{t('hire_development.benefit1')}</p>
                <p>{t('hire_development.benefit2')}</p>
                <p>{t('hire_development.benefit3')}</p>
                <p>{t('hire_development.benefit4')}</p>
                <p>{t('hire_development.benefit5')}</p>

                <h4>{t('hire_development.models_title')}</h4>

                <p><b>{t('hire_development.model1_title')}</b></p>
                <p>{t('hire_development.model1_desc')}</p>

                <p><b>{t('hire_development.model2_title')}</b></p>
                <p>{t('hire_development.model2_desc')}</p>

                <p><b>{t('hire_development.model3_title')}</b></p>
                <p>{t('hire_development.model3_desc')}</p>

                <h4>{t('hire_development.location_title')}</h4>

                <p>{t('hire_development.location_intro')}</p>

                <p><b>{t('hire_development.onsite_title')}</b></p>
                <p>{t('hire_development.onsite_desc')}</p>

                <p><b>{t('hire_development.offsite_title')}</b></p>
                <p>{t('hire_development.offsite_desc')}</p>

                <p><b>{t('hire_development.offshore_title')}</b></p>
                <p>{t('hire_development.offshore_desc')}</p>
              </div>

              <div className="row gutter-y-30 service-details__box-wrapper">
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-consulting"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">{t('hire_development.box_title1')}</Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('hire_development.box_text1')}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-chip"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">{t('hire_development.box_title2')}</Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('hire_development.box_text2')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row gutter-y-30">
                <div className="col-md-6 col-sm-12">
                  <img
                    src="assets/images/services/service-d-2.jpg"
                    className="service-details__sub-image"
                    alt=""
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__caption">
                    <h3 className="service-details__caption__title">
                      Our Benefits
                    </h3>
                    <p className="service-details__caption__text">
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum.
                    </p>
                    <ul className="service-details__caption__list">
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Praesent efficitur quam sit amet
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Nunc cursus dolor id purus euismod
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Quisque tincidunt eros ac place viverra
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}

              {/* <div className="row">
                <div className="col-md-12">
                  <div
                    className="accrodion-grp service-details__accrodion"
                    data-grp-name="service-details__accrodion-1"
                  >
                    {faqs.map((item, index) => (
                      <div
                        className={`accrodion wow fadeInUp ${
                          index === clicked && "active"
                        }`}
                        key={index}
                        data-wow-delay="0ms"
                      >
                        <div className="accrodion-title">
                          <h4 onClick={() => setClicked(index)}>
                            {item.question}
                            <span className="accrodion-icon"></span>
                          </h4>
                        </div>
                        {index === clicked && (
                          <div className="accrodion-content">
                            <div className="inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-lg-4 sidebar-column">
              <ServiceSidebar2/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HireingDev